import React, { Component } from "react";
import DesktopHeader from "../components/DesktopHeader";
import MobileHeader from "../components/MobileHeader";
import { Card } from "@material-ui/core";
import Hunter from "../assets/Hunter.png";
import Spencer from "../assets/Spencer.png";
import "./Team.css";

class Team extends Component {
  render() {
    return (
      <div
        className="team-container"
        style={{
          height: "100%",
          display: "flex",
          flexWrap: "wrap",
          flexDirection: "row",
          fontFamily: "Raleway",
          justifyContent: "center"
        }}
      >
      {window.innerWidth >768?  <DesktopHeader />: <MobileHeader/>}
        <div
          className="row"
          style={{
            display: "flex",
            justifyContent: "center",
            paddingTop:"5%",
            flexWrap: "wrap",
            fontFamily: "Raleway"
          }}
        >
          {/* <div
            className="col"
            style={{
              display: "flex",
              flexWrap: "wrap",
              paddingTop: "5%",
              textAlign: "center",
              justifyContent: "center"
            }}
          >
            <p
              style={{
                color: "white",
                fontWeight: 500,
                fontSize: 60,
                width: "100%"
              }}
            >
              About Us
            </p>
          </div> */}
        </div>

        <div
          className="row"
          style={{
            display: "flex",
            justifyContent: "center",
            width: "100%",
            flexWrap: "wrap",
            fontFamily: "Raleway",
            paddingTop:"8%",
          }}
        >
          <div
            className="col"
            style={{
              margin:"25px"
            }}
          >
            <Card className="card" style={{}}>
              <img
                className="pic"
                src={Hunter}
                alt="Hunter Hillman, CEO of Kinder"
                style={{ width: "260px", height: "200px" }}
              />
              <p
                className="bio"
                style={{ fontWeight: 500, fontSize: 30, width: "100%" }}
              >
                Hunter Hillman
                <br />
                <span style={{ fontWeight: 400, fontSize: 18, width: "100%" }}>
                  Cofounder & CEO
                </span>
              </p>
            </Card>
          </div>
          <div
            className="col"
            style={{
              
              margin:"25px"
            }}
          >
            <Card className="card" style={{}}>
              <img
                className="pic"
                src={Spencer}
                alt="Spencer Hillman, COO of Kinder"
                style={{ width: "260px", height: "200px" }}
              />
              <p
                className="bio"
                style={{ fontWeight: 500, fontSize: 30, width: "100%" }}
              >
                Spencer Hillman
                <br />
                <span style={{ fontWeight: 400, fontSize: 18, width: "100%" }}>
                  Cofounder & COO
                </span>
              </p>
            </Card>
          </div>
          {/* <div
            className="col"
            style={{
              paddingTop: "3%",
              paddingBottom: "3%"
            }}
          >
            <Card className="card" style={{}}>
              <img
                className="pic"
                src={Spencer}
                alt="Spencer Hillman, COO of Kinder"
                style={{ width: "260px", height: "200px" }}
              />

              <p
                className="bio"
                style={{ fontWeight: 500, fontSize: 30, width: "100%" }}
              >
                Jane Doe
                <br />
                <span style={{ fontWeight: 400, fontSize: 18, width: "100%" }}>
                  CTO
                </span>
              </p>
            </Card>
          </div> */}
        </div>

        <div
          className="row"
          style={{
            display: "flex",
            justifyContent: "center",
            width: "100%",
            flexWrap: "wrap",
            fontFamily: "Raleway",
            backgroundColor:"white"
          }}
        >

          <div
            className="col"
            style={{
              display: "flex",
              flexWrap: "wrap",
              textAlign: "center",
              justifyContent: "center",
              margin:"5px"
            }}
          >

          
            <p
              style={window.innerWidth > 1200 ? {
                color:"rgba(12, 80, 135,1)",
                fontWeight: 400,
                fontSize: 18,
                width: "50%",
                textAlign: "left",
                padding: "2% 2% 2% 2%",
                borderRadius: "8px"
              }:{
                color:"rgba(12, 80, 135,1)",
                fontWeight: 400,
                fontSize: 18,
                width: "90%",
                textAlign: "left",
                padding: "2% 2% 2% 2%",
                borderRadius: "8px"
              }}
            >
            <span style={{fontSize:24, fontWeight:"700"}}>Our Story</span>
            <br />
            <br />
              We're two brothers who believe that there's a better way to care
              for those around us. In caring for our aging and disabled father,
              we learned first-hand how helpful and powerful community can be.
              <br />
              <br />
              Since our father's passing, we've put a lot of thought
              into what could have gone differently for us, and for him.
              <br />
              <br />
              We've spoken to hundreds of working people, volunteers, and
              experts around the country, and those conversations led us to a
              simple, age-old idea: many hands make the work light. Adulting is hard, aging is hard,
              and parenting is hard. We believe that technology can help us share these loads and make 
              everyone's life easier, happier, and more fulfilling.
              <br />
              <br />
              We invite you to help us build a Kinder World.
              <br />
              <br />- Hunter & Spencer
            </p>
          </div>
        </div>
        {/* <div
          className="row"
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
            flexWrap: "wrap",
            fontFamily: "Raleway"
          }}
        >
          <div
            className="col"
            style={{
              paddingTop: "5%",
              paddingBottom: "5%",
              marginRight:"3%"
            }}
          >
            <p style={{ color: "white", fontWeight: 500, fontSize: 50 }}>
              Advised by:
            </p>
          </div>
          <div
            className="col"
            style={{
              paddingTop: "5%",
              paddingBottom: "5%",
              marginLeft:"3%"
            }}
          >
            <Card className="card" style={{}}>
              <img
                className="pic"
                src={Hunter}
                alt="Advisor1, Advisor of Kinder"
                style={{ width: "260px", height: "200px" }}
              />
              <p
                className="bio"
                style={{ fontWeight: 600, fontSize: 24, width: "100%" }}
              >
                Victoria Bellotti, Ph.D.
                <br />
                <br/>
                <span style={{ fontWeight: 400, fontSize: 18, width: "100%" }}>
                  UX @ Lyft
                </span>
              </p>
            </Card>
          </div>
          <div
            className="col"
            style={{
              paddingTop: "5%",
              paddingBottom: "5%"
            }}
          >
            <Card className="card" style={{}}>
              <img
                className="pic"
                src={Hunter}
                alt="Advisor1, Advisor of Kinder"
                style={{ width: "260px", height: "200px" }}
              />
              <p
                className="bio"
                style={{ fontWeight: 500, fontSize: 30, width: "100%" }}
              >
                Jane Doe
                <br />
                <span style={{ fontWeight: 400, fontSize: 18, width: "100%" }}>
                  Role at Company Name
                </span>
              </p>
            </Card>
          </div>
        </div> */}
      </div>
    );
  }
}

export default Team;
